import * as jQuery from 'jquery'

export const $ = jQuery;
export const $jqBody = jQuery('body');
export const $jqHtml = jQuery('html');
export const Pages = {
    HOME : 'home-page',
};
